import React from 'react';
import Svg, { Use as NativeUse, Symbol, Path, G } from 'react-native-svg';
import { useIsFocused } from '@react-navigation/native';
import { StatusBar, SafeAreaView, View, Platform } from 'react-native';

// https://github.com/necolas/react-native-web/commit/4905bb98b7cb314e0a528e505d7e282f692ded3f
// Will be fixed in react-native-web 0.17
const Use = Platform.OS === 'web' ? 'use' : NativeUse;

import { Color } from '@src/styles';
import { APPROX_STATUSBAR_HEIGHT } from '@src/constants';

export function FullLogoSymbol() {
  return (
    <Symbol id="full-logo" viewBox="0 0 173 102">
      <G fill="none" fillRule="evenodd">
        <G fill="#8b688d">
          <Path d="M13.398 95.623c2.343 0 4.479-.558 6.414-1.674 1.933-1.116 3.32-2.457 4.155-4.026v-6.34h-7.523c-2.89 0-5.176.665-6.862 1.995-1.683 1.33-2.525 2.946-2.525 4.845 0 1.687.525 2.972 1.577 3.863 1.05.891 2.639 1.337 4.764 1.337zm11.36 5.128a46.59 46.59 0 01-.503-2.813 28.93 28.93 0 01-.252-2.495c-1.362 1.735-3.062 3.18-5.105 4.329-2.044 1.152-4.223 1.728-6.539 1.728-4.035 0-7.106-.981-9.206-2.939C1.05 96.601 0 93.841 0 90.281c0-3.656 1.485-6.478 4.46-8.46 2.975-1.983 7.053-2.975 12.233-2.975h7.274v-4.487c0-2.257-.715-4.043-2.15-5.362-1.432-1.316-3.426-1.975-5.981-1.975-1.768 0-3.33.225-4.676.675-1.349.452-2.444 1.069-3.28 1.854l-.75 4.059H1.683v-7.48c1.767-1.399 3.906-2.524 6.411-3.365 2.51-.844 5.23-1.265 8.17-1.265 4.393 0 7.953 1.116 10.676 3.348 2.723 2.232 4.085 5.425 4.085 9.583v18.557c0 .497.005.985.016 1.46s.043.947.09 1.425l2.868.391v4.487zM49.632 66.96l-4.551.703 7.808 21.633.628 2.74h.21l.665-2.74 7.563-21.633-4.587-.704V62.5H72v4.46l-3.116.527L56.177 100.5h-5.214L38.116 67.487 35 66.96V62.5h14.632zM78 96.074l5.61-.983V67.944L78 66.96V62.5h12.39v32.591l5.61.983v4.426H78zM112.632 66.96l-4.549.703 7.806 21.633.628 2.74h.212l.663-2.74 7.563-21.633-4.587-.704V62.5H135v4.46l-3.113.527-12.708 33.013h-5.216l-12.845-33.013L98 66.96V62.5h14.632zM152.399 95.623c2.34 0 4.48-.558 6.412-1.674 1.938-1.116 3.32-2.457 4.158-4.026v-6.34h-7.526c-2.89 0-5.176.665-6.86 1.995-1.684 1.33-2.526 2.946-2.526 4.845 0 1.687.525 2.972 1.575 3.863 1.053.891 2.64 1.337 4.767 1.337zm11.357 5.128a48.442 48.442 0 01-.502-2.813c-.118-.83-.201-1.66-.249-2.495-1.362 1.735-3.065 3.18-5.106 4.329a13.102 13.102 0 01-6.539 1.728c-4.038 0-7.107-.981-9.207-2.939-2.105-1.96-3.153-4.72-3.153-8.28 0-3.656 1.487-6.478 4.459-8.46 2.974-1.983 7.055-2.975 12.238-2.975h7.272v-4.487c0-2.257-.718-4.043-2.15-5.362-1.433-1.316-3.427-1.975-5.985-1.975-1.767 0-3.324.225-4.673.675-1.352.452-2.443 1.069-3.28 1.854l-.754 4.059h-5.445v-7.48c1.767-1.399 3.906-2.524 6.414-3.365 2.508-.844 5.23-1.265 8.17-1.265 4.394 0 7.954 1.116 10.675 3.348 2.725 2.232 4.087 5.425 4.087 9.583v18.557c0 .497.005.985.018 1.46.012.475.039.947.086 1.425l2.868.391v4.487zM90 27a4.5 4.5 0 11-8.999-.001A4.5 4.5 0 0190 27" />
        </G>
        <Path
          d="M76.787 36.806c0-3.502-3.177-6.301-3.177-9.805S77 20.691 77 17.194c0-2.592-2.19-4.694-4.894-4.694-2.702 0-4.893 2.102-4.893 4.694 0 3.497 3.45 6.277 3.45 9.807 0 3.528-3.663 6.002-3.663 9.805 0 2.592 2.19 4.694 4.894 4.694 2.702 0 4.893-2.102 4.893-4.694M103.787 36.806c0-3.502-3.177-6.301-3.177-9.805s3.39-6.31 3.39-9.807c0-2.592-2.19-4.694-4.894-4.694-2.702 0-4.893 2.102-4.893 4.694 0 3.497 3.45 6.277 3.45 9.807 0 3.528-3.663 6.002-3.663 9.805 0 2.592 2.19 4.694 4.894 4.694 2.702 0 4.893-2.102 4.893-4.694M90 48.73c0 2.635-1.926 4.77-4.444 4.77C83.04 53.5 81 51.365 81 48.73c0-2.636 2.04-11.23 4.558-11.23C88.074 37.5 90 46.094 90 48.73M115 27a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0M65 27c0 2.484-2.016 4.5-4.499 4.5A4.5 4.5 0 1165 27M90 5.27C90 2.635 88.074.498 85.556.5 83.04.5 81 2.635 81 5.27c0 2.636 2.04 11.23 4.558 11.23C88.074 16.498 90 7.904 90 5.27"
          fill="#008689"
        />
      </G>
    </Symbol>
  );
}

const LogoSymbol = ({ color }: { color?: boolean }) => (
  <Symbol id="logo" viewBox="0 0 45 38">
    <G id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <G id="Home" transform="translate(-30.000000, -50.000000)" fill="#FFFFFF">
        <G id="Brand-element-white" transform="translate(30.000000, 50.000000)">
          <Path
            d="M15.8504564,25.4374759 C15.8504564,22.7825472 13.6263352,20.6577561 13.6263352,18 C13.6263352,15.3422439 16,13.2146254 16,10.5611104 C16,8.59323994 14.4664983,7 12.5740921,7 C10.6830453,7 9.1495436,8.59323994 9.1495436,10.5611104 C9.1495436,13.2146254 11.563993,15.3224521 11.563993,18 C11.563993,20.6775479 9,22.5535278 9,25.4374759 C9,27.4053464 10.5335017,29 12.4245485,29 C14.3169547,29 15.8504564,27.4053464 15.8504564,25.4374759"
            id="Fill-6"
            fill={color ? Color.styleGuide.LogoCyan : undefined}
          ></Path>
          <Path
            d="M35.8517871,25.4374759 C35.8517871,22.7825472 33.6272339,20.6577561 33.6272339,18 C33.6272339,15.3422439 36,13.2146254 36,10.5611104 C36,8.59323994 34.4662005,7 32.5747863,7 C30.6833722,7 29.1482129,8.59323994 29.1482129,10.5611104 C29.1482129,13.2146254 31.5644911,15.3224521 31.5644911,18 C31.5644911,20.6775479 29,22.5535278 29,25.4374759 C29,27.4053464 30.5337995,29 32.4252137,29 C34.3179876,29 35.8517871,27.4053464 35.8517871,25.4374759"
            id="Fill-8"
            fill={color ? Color.styleGuide.LogoCyan : undefined}
          ></Path>
          <Path
            d="M26,34.4215116 C26,36.3982558 24.4319659,38 22.5,38 C20.5666125,38 19,36.3982558 19,34.4215116 C19,32.4447674 20.5666125,26 22.5,26 C24.4333875,26 26,32.4447674 26,34.4215116"
            id="Fill-10"
            fill={color ? Color.styleGuide.LogoCyan : undefined}
          ></Path>
          <Path
            d="M26,18.5 C26,20.4333875 24.4319659,22 22.5,22 C20.5666125,22 19,20.4333875 19,18.5 C19,16.5666125 20.5666125,15 22.5,15 C24.4333875,15 26,16.5666125 26,18.5"
            id="Fill-12"
            fill={color ? Color.styleGuide.LogoLilac : undefined}
          ></Path>
          <Path
            d="M25.7927,4.34835 C25.7927,6.38835 24.1382,11.93835 22.0997,11.93835 C20.0597,11.93835 18.4067,6.38835 18.4067,4.34835 C18.4067,2.30835 20.0597,0.65535 22.0997,0.65535 C24.1397,0.65535 25.7927,2.30835 25.7927,4.34835"
            id="Fill-14"
            fill={color ? Color.styleGuide.LogoCyan : undefined}
          ></Path>
          <Path
            d="M45,18.5 C45,20.4333875 43.4319659,22 41.5,22 C39.5666125,22 38,20.4319659 38,18.5 C38,16.5666125 39.5666125,15 41.5,15 C43.4319659,15 45,16.5666125 45,18.5"
            id="Fill-17"
            fill={color ? Color.styleGuide.LogoCyan : undefined}
          ></Path>
          <Path
            d="M7,18.5 C7,20.4333875 5.43196588,22 3.5,22 C1.56661251,22 0,20.4319659 0,18.5 C0,16.5666125 1.56661251,15 3.5,15 C5.43338749,15 7,16.5666125 7,18.5"
            id="Fill-19"
            fill={color ? Color.styleGuide.LogoCyan : undefined}
          ></Path>
        </G>
      </G>
    </G>
  </Symbol>
);

export const LogoInner = ({
  color,
  width,
  height,
}: {
  color?: boolean;
  width: number | string;
  height: number | string;
}) => {
  return (
    <>
      <LogoSymbol color={color} />
      <Use href="#logo" x="0" y="0" width={width} height={height} />
    </>
  );
};

export function Logo({
  color,
  width,
  height,
}: {
  color?: boolean;
  height: number | string;
  width: number | string;
}) {
  const a11yProps = {
    accessibilityRole: 'image' as const,
    [Platform.OS === 'web'
      ? (('aria-label' as any) as 'accessibilityLabel')
      : 'accessibilityLabel']: 'Logo',
  };
  return (
    <Svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} accessible {...a11yProps}>
      <LogoInner width={width} height={height} color={color} />
    </Svg>
  );
}

type Position = [number, number];
export const SvgWithLogoAndBezierCurve = ({
  showLogo,
  viewBoxWidth,
  viewBoxHeight,
  startPoint,
  firstControlPoint,
  secondControlPoint,
  endPoint,
  fill = Color.styleGuide.LogoCyan,
  inverse,
}: {
  showLogo?: boolean;
  viewBoxHeight: number;
  viewBoxWidth: number;
  startPoint: Position;
  firstControlPoint: Position;
  secondControlPoint: Position;
  endPoint: Position;
  fill?: string;
  inverse?: boolean;
}) => {
  const a11yProps = showLogo
    ? {
        accessibilityRole: 'image' as const,
        [Platform.OS === 'web'
          ? (('aria-label' as any) as 'accessibilityLabel')
          : 'accessibilityLabel']: 'Aviva Logo',
      }
    : undefined;

  return (
    <View
      style={{
        width: '100%',
        aspectRatio: viewBoxWidth / viewBoxHeight,
      }}
    >
      <Svg
        width="100%"
        height="100%"
        viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
        preserveAspectRatio="none"
        accessible={showLogo}
        {...a11yProps}
      >
        <LogoSymbol />
        <Path
          d={`
          M ${startPoint}
          C ${firstControlPoint}
            ${secondControlPoint}
            ${endPoint}
          L ${inverse ? `${viewBoxWidth},${viewBoxHeight} 0,${viewBoxHeight}` : `${viewBoxWidth},0`}
          L 0,${0}
        `}
          fill={fill}
          strokeWidth={inverse ? 0 : 1}
          stroke={fill}
        />
        {showLogo ? <Use href="#logo" x="10" y="0" width="30" height="25" /> : null}
      </Svg>
    </View>
  );
};

export default function ScreenHeader(props: { color?: string; hideLogo?: boolean }) {
  const isFocused = useIsFocused();
  return (
    <View style={{ width: '100%', zIndex: 1, position: 'absolute', top: 0 }}>
      <SafeAreaView
        style={{
          backgroundColor: props.color ?? Color.styleGuide.LogoCyan,
          paddingTop: APPROX_STATUSBAR_HEIGHT + 10,
        }}
      >
        {isFocused ? (
          <StatusBar barStyle="light-content" translucent backgroundColor="#00000000" />
        ) : null}
      </SafeAreaView>
      <SvgWithLogoAndBezierCurve
        showLogo={!props.hideLogo}
        viewBoxHeight={50}
        viewBoxWidth={300}
        startPoint={[0, 40]}
        firstControlPoint={[50, 70]}
        secondControlPoint={[200, -20]}
        endPoint={[300, 10]}
        fill={props.color}
      />
    </View>
  );
}
